// @ts-nocheck
import * as Types from '@src/types/graphql-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as React from 'react';
import * as ApolloReactComponents from '@apollo/client/react/components';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
const defaultOptions = {} as const;
export type CreateCustomPromotionalBundleMutationVariables = Types.Exact<{
  input: Types.CustomPromotionalBundleInput;
}>;


export type CreateCustomPromotionalBundleMutation = { __typename?: 'Mutation', createCustomPromotionalBundle?: boolean | null };


export const CreateCustomPromotionalBundleDocument = gql`
    mutation CreateCustomPromotionalBundle($input: CustomPromotionalBundleInput!) {
  createCustomPromotionalBundle(input: $input)
}
    `;
export type CreateCustomPromotionalBundleMutationFn = Apollo.MutationFunction<CreateCustomPromotionalBundleMutation, CreateCustomPromotionalBundleMutationVariables>;
export type CreateCustomPromotionalBundleComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<CreateCustomPromotionalBundleMutation, CreateCustomPromotionalBundleMutationVariables>, 'mutation'>;

    export const CreateCustomPromotionalBundleComponent = (props: CreateCustomPromotionalBundleComponentProps) => (
      <ApolloReactComponents.Mutation<CreateCustomPromotionalBundleMutation, CreateCustomPromotionalBundleMutationVariables> mutation={CreateCustomPromotionalBundleDocument} {...props} />
    );
    

/**
 * __useCreateCustomPromotionalBundleMutation__
 *
 * To run a mutation, you first call `useCreateCustomPromotionalBundleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCustomPromotionalBundleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCustomPromotionalBundleMutation, { data, loading, error }] = useCreateCustomPromotionalBundleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCustomPromotionalBundleMutation(baseOptions?: Apollo.MutationHookOptions<CreateCustomPromotionalBundleMutation, CreateCustomPromotionalBundleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCustomPromotionalBundleMutation, CreateCustomPromotionalBundleMutationVariables>(CreateCustomPromotionalBundleDocument, options);
      }
export type CreateCustomPromotionalBundleMutationHookResult = ReturnType<typeof useCreateCustomPromotionalBundleMutation>;
export type CreateCustomPromotionalBundleMutationResult = Apollo.MutationResult<CreateCustomPromotionalBundleMutation>;
export type CreateCustomPromotionalBundleMutationOptions = Apollo.BaseMutationOptions<CreateCustomPromotionalBundleMutation, CreateCustomPromotionalBundleMutationVariables>;